<template>

<core-dropdown class="input" trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick">

	<core-button v-on:click.native="onToggleClick" tooltip="Views" :caret="true" theme="filter" icon="table-layout" :iconOnly="$isDesktop" :text="layoutName" :icon-left="$isMobile" />
	
	<portal to="mobileactions" v-if="$isMobile && $route.meta.hasActions">

		<core-button 
			v-on:click.native="onToggleClick" 
			theme="filter" 
			icon="table-layout" 
			text="View" 
			:icon-left="true" 
		/>
	
	</portal>
	
	<core-dropdown-list title="Views" class="input-options" :expanded="is.expanded" theme="filter" :caret="true" align="left" type="button" v-on:close="is.expanded = false">

		<core-dropdown-item type="link" v-for="view in views" :key="view.id">{{ view.name }}</core-dropdown-item>

		<core-dropdown-item type="link" :is-ticked="true">Default</core-dropdown-item>

	</core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'filter', 'page'
	],
	
	data: function() {

		return {
			is: {
				expanded: false
			}
		}

	},

	computed: {

		layoutName: function() {

			return '<b>Default</b> view'

		},

		views: function() {

			return this.$store.getters['data/views/list']

		},

	},

	methods: {

		onCreateClick: function() {

			this.$pubsub.$emit('open.modal', 'viewsManageCreate')

			this.is.expanded = false

		},

		onManageClick: function() {

			this.$pubsub.$emit('open.modal', 'viewsManage')

			this.is.expanded = false

		},

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		}

	}

}

</script>

<style scoped>

</style>
